if (!customElements.get("ops-cart-item")) {
	customElements.define(
		"ops-cart-item",
		class OpsCartItem extends HTMLElement {
			classIsDisabled = "opsButton--isDisabled";

			connectedCallback() {
				this.elements = {
					root: this,
					minus: this.querySelector(".opsCartItem-minus"),
					plus: this.querySelector(".opsCartItem-plus"),
					quantity: this.querySelector(".opsCartItem-quantity"),
				};

				this.key = this.dataset.key;

				// TODO: reidenzon - Debounce this!
				ops.onTap(this.elements.minus, (event) => this.setQuantity(-1));
				ops.onTap(this.elements.plus, (event) => this.setQuantity(+1));

				this.elements.quantity.addEventListener("change", () => this.onChange());
				this.elements.quantity.addEventListener("keydown", (event) => {
					// TODO: reidenzon - Better way to prevent SUBMIT event on Enter key?!
					event.key === "Enter" && event.preventDefault();
				});

				this.setState();
			}

			disconnectedCallback() {
				// TODO: reidenzon - Something interesting!
			}

			onChange() {
				const quantity = this.elements.quantity;
				const value = Number(quantity.value) || 0;
				console.log("OpsCartItem.onChange", { value });
				this.setQuantity(0);
			}

			setQuantity(delta) {
				const quantity = this.elements.quantity;
				const vMin = 1;
				const vMax = Number(quantity.max) || 0;
				const v = Number(quantity.value) || 0;
				const vNew = Math.max(vMin, Math.min(vMax, v + delta));
				// console.log("OpsCartItem.setQuantity", { vMin, vMax, v, delta, vNew });
				quantity.value = vNew;
				this.setState();
				this.updateCartQuantity(vNew);
			}

			setState() {
				const quantity = this.elements.quantity;
				const vMax = Number(quantity.max) ?? 0;
				const v = Number(quantity.value) ?? 0;

				if (v <= 1) {
					this.elements.minus.classList.add(this.classIsDisabled);
				} else {
					this.elements.minus.classList.remove(this.classIsDisabled);
				}

				if (v >= vMax) {
					this.elements.plus.classList.add(this.classIsDisabled);
				} else {
					this.elements.plus.classList.remove(this.classIsDisabled);
				}
			}

			async updateCartQuantity(qty) {
				const key = this.key;
				const url = `${ops.routes.cartChangeUrl}`;
				console.log("OpsCartItem.updateCartQuantity", { key, qty });

				try {
					const response = await fetch(url, {
						method: "POST",
						headers: { "Content-Type": "application/json" },
						body: JSON.stringify({
							id: key,
							quantity: qty,
						}),
					});
					const text = await response.text();
					// TODO: reidenzon - Update the form.
					window.location = ops.routes.cartUrl;
				} catch (e) {
					// TODO: reidenzon - Something interesting!
					debugger;
				}
			}
		},
	);
}
